import React from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import LineTypeSettings from './LineTypeSettings';
import LineTypeLinks from './LineTypeLinks';

import './LineTypeTabs.css';
import LineTypeOther from './LineTypeOther';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function ProfileTabs(props) {
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  //const user = useContext(UserContext);
  console.log('', props);
  return (
    <React.Fragment>
      <Tabs value={value} onChange={handleChange} className="mb-2 tabs-class">
        <Tab label="Links" {...a11yProps(0)} />
        <Tab label="Line Synch" {...a11yProps(1)} />.
        <Tab label="Other" {...a11yProps(2)} />.
      </Tabs>
      <hr className="my-2" />

      <TabPanel className="tab-content" value={value} index={0}>
        <LineTypeLinks
          LineType={props.LineType}
          UpdateLineType={props.UpdateLineType}
        ></LineTypeLinks>
      </TabPanel>
      <TabPanel className="tab-content" value={value} index={1}>
        <LineTypeSettings
          LineType={props.LineType}
          UpdateLineType={props.UpdateLineType}
        ></LineTypeSettings>
      </TabPanel>
      <TabPanel className="tab-content" value={value} index={2}>
        <LineTypeOther
          LineType={props.LineType}
          UpdateLineType={props.UpdateLineType}
        ></LineTypeOther>
      </TabPanel>
    </React.Fragment>
  );
}
